const issueExportUrl = (
  collectId, format, { draftId, search, issueStatus, issueContent, selectedIds = new Set() }
) => {
  const params = new URLSearchParams()
  params.set('export_format', format)
  if (draftId)
    params.set('draft_id', String(draftId))
  if (search)
    params.set('q', search)
  if (issueStatus)
    params.set('issue_status', issueStatus)
  if (issueContent)
    params.set('issue_content', issueContent)
  // Scope the export to the checked rows; empty selection falls back to the
  // Filtered set (q / issue_status / issue_content), preserving the export-everything default.
  selectedIds.forEach(id => params.append('issue_ids[]', String(id)))
  return `/collects/${collectId}/issues/export?${params.toString()}`
}

export default issueExportUrl
